import { DateTime } from 'luxon';
import getFiscalEntitiesFromInterval from '../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/FiscalPeriodsProvider/getFiscalEntitiesFromInterval';
import getCurrentFiscalEntity from '../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/FiscalPeriodsProvider/getCurrentFiscalEntity';

const getLastYearEntityId = (
  currentRangeId: string,
  fiscalEntities:
    | FixedPeriods.FiscalPeriod[]
    | FixedPeriods.FiscalQuarter[]
    | FixedPeriods.FiscalYear[],
) => {
  const currentYear = currentRangeId.split('-')[0];
  const prevYear = parseInt(currentYear) - 1;
  const prevId = currentRangeId.replace(currentYear, prevYear.toString());

  const prevYearEntityIdx = fiscalEntities.findIndex((e) => e.id === prevId);
  return fiscalEntities[prevYearEntityIdx];
};

const getComparisonLastYearFiscalEntities = (
  startDate: DateTime,
  endDate: DateTime | undefined,
  interval: FixedPeriods.FiscalType,
  currentToDate: boolean,
  fiscalRanges: FixedPeriods.AllFiscals,
) => {
  let fiscalEntities:
    | FixedPeriods.FiscalPeriod[]
    | FixedPeriods.FiscalQuarter[]
    | FixedPeriods.FiscalYear[]
    | undefined;

  fiscalEntities = getFiscalEntitiesFromInterval(interval, fiscalRanges);
  if (!fiscalEntities) {
    throw new Error(`No fiscal entities found for interval ${interval}`);
  }

  const currentRangeStartIndex = fiscalEntities.findIndex(
    (e) => e.startDate === startDate.toISODate(),
  );
  const currentRangeEndIndex = fiscalEntities.findIndex(
    (e) => e.endDate === endDate?.toISODate(),
  );
  const currentRangeStart = fiscalEntities[currentRangeStartIndex];
  const currentRangeEnd = currentToDate
    ? getCurrentFiscalEntity(fiscalEntities)
    : fiscalEntities[currentRangeEndIndex];

  if (!currentRangeStart || !currentRangeEnd) {
    return {
      startDate: undefined,
      endDate: undefined,
    };
  }

  const previousYearRangeStart = getLastYearEntityId(
    currentRangeStart.id,
    fiscalEntities,
  );

  if (!previousYearRangeStart) {
    return {
      startDate: undefined,
      endDate: undefined,
    };
  }

  if (!currentRangeEnd) {
    return {
      startDate: DateTime.fromISO(previousYearRangeStart.startDate),
    };
  }

  const previousYearRangeEnd = getLastYearEntityId(
    currentRangeEnd.id,
    fiscalEntities,
  );

  let comparisonEndDate: DateTime | undefined;
  if (currentToDate) {
    const diffDays = DateTime.now()
      .minus({ days: 1 })
      .startOf('day')
      .diff(DateTime.fromISO(currentRangeEnd.startDate), 'days').days;

    comparisonEndDate = DateTime.fromISO(previousYearRangeEnd.startDate).plus({
      days: diffDays,
    });
  } else {
    comparisonEndDate = DateTime.fromISO(
      previousYearRangeEnd?.endDate || previousYearRangeStart?.endDate,
    );
  }
  return {
    startDate: DateTime.fromISO(previousYearRangeStart?.startDate),
    endDate: comparisonEndDate,
  };
};

export default getComparisonLastYearFiscalEntities;
